const scheduleTypes = {
    types: {
        VIBE: 0,
        REGULATION: 1,
        MUTE: 2,
        MOOD_SUSTAIN: 3, 
        SOURCE: 4
    }
}

export default scheduleTypes;